const DATE_LOCALES = {
  en: "en-US",
  tw: "zh-TW",
  "zh-tw": "zh-TW",
  zh_tw: "zh-TW",
  zh: "zh-CN",
  jp: "ja-JP",
  th: "th-TH",
  korean: "ko-KR",
};

export const getImportDateLocale = (language) =>
  DATE_LOCALES[language] || "en-US";
